import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Assessment() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/contact#contact-form');
  }, [navigate]);

  return null;
}
